import React, { useEffect, useState } from "react";
import "./PremiumPlanDetails.css";
import PlanCard from "../../Components/PlanCard/PlanCard";
import { useNavigate, useParams } from "react-router-dom";
import PlanDetailsCard from "../../Components/PlanDetailsCard/PlanDetailsCard";
import axios from "axios";
import { BASE_URL } from "../../BASE_URL";

const PremiumPlanDetails = () => {
  const [membershipdata, setMembershipData] = useState();
  const [memData, setMemData] = useState("");
  const [userData, setUserData] = useState();
  const { id } = useParams();
  const token = localStorage.getItem("saptvidhiUserToken");
  const [isModalOpen, setIsModalOpen] = useState(true);
  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/profile/premimumdetails`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: localStorage.getItem("saptvidhiUserToken"),
          },
        }
      );
      if (!response.ok) {
      }

      const responseData = await response.json();
      if (responseData?.status === "OK") {
        setMembershipData(responseData?.data?.[0]);
        setUserData(responseData?.data?.[0]?.count_contact_details);
        setMemData(responseData?.data?.[0]);
      }
      // setMembershipData(responseData?.data?.[0]);
    } catch (error) {
      alert(error);
    }
  };
  useEffect(() => {

    fetchData();
  }, []);

  const [seenContactDetails, setSeenContactDetails] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const handleContactButtonClick = (userId) => {
    setSelectedUserId(userId);
    setSeenContactDetails(null);
  };
  const handleClickYes = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/count_of_contact_details`,
        { profile_id: selectedUserId },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.code === 200) {
        setSeenContactDetails(response.data.data);
      }
      // });
    } catch (err) {
      alert(err);
    }
    // setOpenPopUp(false);
  };

  const navigate = useNavigate();

  const renderFeatures = (data) => {
    return data?.membership_feature_id?.map((feature) => {
      const matchingFeature = data?.membership_feature_name?.find(
        (item) => item._id === feature?.membership_id
      );
      if (matchingFeature) {
        return (
          <div className="d-flex px-2">
            <p style={{ fontSize: "12px" }}>
              {feature?.membership_feature_status ? "✅" : "❌"}{" "}
            </p>
            <p
              className="ps-1"
              style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.9)" }}
            >
              {matchingFeature?.feature_name}
            </p>
          </div>
        );
      }
      return null;
    });
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <div className="container my-4 px-4" style={{ flex: 1 }}>
          <div className="row gy-5 gx-4" style={{ flex: 1 }}>
            <div className="col-lg-3 col-md-4 col-sm-12 col-12">
              <div className="package_info_container">
                <div className="text-center mb-3">
                  <h5>Package Details</h5>
                </div>
                <div className="package-info-card pt-3 px-3">
                  <div className="d-flex justify-content-between">
                    <p>Active Package : </p>
                    <p style={{ fontWeight: "600" }}>{memData?.membership_plans?.[0]?.plan_name}</p>
                  </div>
                  <div className="d-flex justify-content-between">
                    <p>Activation Date : </p>
                    <p style={{ fontWeight: "600" }}>{memData.membership_date && typeof memData.membership_date === "string" ? memData.membership_date.slice(0, 10) : "Invalid date"}</p>
                  </div>
                  <div className="d-flex justify-content-between">
                    <p>Remaining Days : </p>
                    <p style={{ fontWeight: "600" }}>{memData.remaining_days}</p>
                  </div>
                  <div className="d-flex justify-content-between">
                    <p>Seen contact : </p>
                    <p style={{ fontWeight: "600" }}>{memData.seen_contact}</p>
                  </div>
                  <div className="d-flex justify-content-between">
                    <p>Membership Plan Status: </p>
                    <p style={{ fontWeight: "600" }}>{memData.membershipplan_status}</p>
                  </div>
                </div>
              </div>
            </div>
            {seenContactDetails ? (
              <div
                className={`modal fade ${isModalOpen ? "show" : ""}`}
                id="exampleModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-body">
                      Phone number : {seenContactDetails?.[0]?.contact_no}
                    </div>
                    <div className="modal-body">
                      Email : {seenContactDetails?.[0]?.email}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className={`modal fade ${isModalOpen ? "show" : ""}`}
                id="exampleModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-body">
                      Are you sure you want to see the contact of this user?
                    </div>
                    <div
                      className="modal-footer justify-content-center"
                      style={{ borderTop: "none" }}
                    >
                      <button
                        type="button"
                        className=""
                        data-dismiss="modal"
                        style={{
                          border: "none",
                          width: "90px",
                          padding: "7px 10px",
                          borderRadius: "10px",
                          color: "white",
                          background:
                            "linear-gradient(180deg, #cf166f 0%, rgba(253, 7, 7, 0.5) 100%)",
                        }}
                        onClick={handleModalClose}
                      >
                        No
                      </button>
                      <button
                        type="button"
                        className=" md-4"
                        onClick={handleClickYes}
                        style={{
                          border: "none",
                          width: "90px",
                          padding: "7px 10px",
                          borderRadius: "10px",
                          color: "white",
                          background:
                            "linear-gradient(180deg, #cf166f 0%, rgba(253, 7, 7, 0.5) 100%)",
                        }}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="col-lg-9 col-md-8 col-sm-12 col-12">
              <div className="row gy-3">
                <div className="col-12 ">
                  <h5>Seen contact details</h5>
                </div>
                <div className="seen-contacts-grid">
                  {userData && userData.length > 0 ? (
                    [...userData]
                      .sort((a, b) => new Date(b.date_and_time) - new Date(a.date_and_time))
                      .map((user, index) => (
                        <div key={index} className="d-flex justify-content-center">
                          <div className="package_border_detail py-3" style={{ width: "100%" }}>
                            <div className="d-flex justify-content-center">
                              <div>
                                <img
                                  className="me-2"
                                  src={user?.contect_user_profiles?.[0]?.profile_photo}
                                  alt="photo"
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "50%",
                                  }}
                                />
                              </div>
                              <div>
                                <div className="d-flex ">
                                  <span className="mb-1">Name</span>
                                  <span className="mx-1"> :</span>
                                  <span className="mb-0 ms-1">
                                    {user?.contect_user_profiles?.[0]?.user_name}
                                  </span>
                                </div>
                                <p>Date : <span>{user?.date_and_time.slice(0, 10)}</span></p>
                              </div>
                            </div>
                            <div>
                              <div className="package_contact_button d-flex justify-content-center">
                                <button
                                  data-toggle="modal"
                                  data-target="#exampleModal"
                                  onClick={() => handleContactButtonClick(user?.contect_user_profiles?.[0]?._id)}
                                >
                                  Contact
                                </button>
                                <button
                                  onClick={() =>
                                    navigate(
                                      `/userprofile/${user?.contect_user_profiles?.[0]?._id}`
                                    )
                                  }
                                >
                                  View
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                  ) : (
                    <div className="col-12 text-center">
                      <p>No contact details available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PremiumPlanDetails;